module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"noItemsText":"No benefits to show."},"fi":{"noItemsText":"Jäsenetuja ei löytynyt."},"sv":{"noItemsText":"Det finns inga medlemsförmåner att visa."}}')
  delete Component.options._Ctor
}
